// Chat page — resolves the route's merchant into the chat's brand scope and
// renders ChatInterface with the authenticated user's email/name.

import { useMe } from "@/api/me";
import ChatInterface from "@/pages/ask/components/ChatInterface";
import { brandFromMerchant } from "@/pages/ask/lib/data";
import { useMerchant } from "@/providers/MerchantProvider";

export default function Chat() {
  const { data: user } = useMe();
  const merchantId = useMerchant();

  const name = user ? [user.firstName, user.lastName].filter(Boolean).join(" ").trim() : undefined;

  // The route's merchant is the only scope Ask Unbox can query, so build the
  // brand from the user's merchant record rather than a separate lookup.
  const merchant =
    user?.merchants.find((m) => m.id === merchantId) ??
    user?.workspaces?.flatMap((w) => w.merchants).find((m) => m.id === merchantId);
  const scope = brandFromMerchant({ id: merchantId, name: merchant?.name ?? "", vertical: merchant?.vertical });

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <ChatInterface userEmail={user?.email ?? ""} userName={name || undefined} scope={scope} />
    </div>
  );
}
